export default "__VITE_ASSET__DPkG0WTq__"